import FieldValidationError from "./FieldValidationError";

const InputWeight = (props) => {

    const handleKeyDown = (event) => {
        // Permite números, vírgula (,) e teclas de controle
        if (!/^[0-9,]$/.test(event.key) && 
            !['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(event.key)) {
            event.preventDefault();
        }
    };

    const handleChange = (event) => {
        let value = event.target.value.replace(/[^0-9,]/g, ''); // Mantém apenas números e vírgula

        // Substitui múltiplas vírgulas por uma única
        const parts = value.split(',');
        if (parts.length > 2) {
            value = parts[0] + ',' + parts.slice(1).join('');
        }

        props.onChange && props.onChange({ target: { name: props.name, value } });
    };

    return (
        <>
            <input
                type="text"
                className="form-control"
                onKeyDown={handleKeyDown} 
                onChange={handleChange}
                value={props.value}
                inputMode="decimal" // Garante teclado decimal em mobile
                // Ajustado para aceitar valores inteiros e decimais (com até 3 casas após a vírgula)
                pattern="^\d*(,\d{0,3})?$" // Aceita números inteiros ou até 3 casas decimais
                {...props}
            />
            <FieldValidationError error={props.error} />
        </>
    );
};

export default InputWeight;